module.exports = __webpack_public_path__ + "static/media/7page_05.e18a8a5b.jpg";